import { GlobalClassInstance } from '@commoncore/constants/GlobalClass';
import { BANNER_CONSTANTS } from '@commoncore/constants/bannerConstants';
import { IndexDBImplementation } from '@commoncore/implementation/IndexDBImplementation';
import { AppEvents } from '@commoncore/utils/app-events';
import { UPLOAD_CONS } from '@core/constants/UploadConstants';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { ENV_CONFIG } from '@env-properties/environment-config';
import { IndexedDBModule } from '../database/IndexedDBManager';
import { UploadLargeFile } from './UploadLargeFile';
import { UploadSmallFile } from './UploadSmallFile';
import { UploadUtility } from './UploadUtil';
import { dragnDropObject } from './dragnDropObject';
declare var ProgressBar: any;
export class UploadFolderImplementation {

  protected http: any;
  protected router: any;
  protected universalService: any;
  static singleInstance: any;
  localStorageService: any;
  cacheImpl:IndexDBImplementation;
  db:IndexedDBModule;
  cleverTapEventsService:any;
  listService:any;
  customMetadata:any;
  uploadLargeFile: any;
  uploadSmallFile: any;
  failedUploads:any = [];
  remainingQuota:any;
  folderFilesDnD:any = []
  fileUploadInvokedDnD:boolean = false
  notAllowedExt:any;
  private filesPreparinginFolder: any = [];
  uploadUtil: UploadUtility;

  constructor(protected globalService) {
    this.initializeProperties()
  }

  initializeProperties() {
    this.http = this.globalService.getHttpClientRef();
    this.router = this.globalService.getRouterRef();
    this.universalService = this.globalService.getUniversalServiceRef();
    this.localStorageService = this.globalService.getLocalStorageSvcRef();
    // this.universalService.MarkNewObjArray = [];
    this.cacheImpl = IndexDBImplementation.getInstance(this.globalService)
    this.db = IndexedDBModule.getInstance(this.globalService);
    this.cleverTapEventsService =  this.globalService.getCleverTapEventsvc()
    this.customMetadata = this.globalService.getCustomMetadataServiceRef();
    this.listService = this.globalService.getListServiceRef();
    this.uploadLargeFile = UploadLargeFile.getInstance(this.globalService);
    this.uploadSmallFile = UploadSmallFile.getInstance(this.globalService)
    this.notAllowedExt = UPLOAD_CONS.FILE_FORMATS['NOTALLOWED'];
    this.uploadUtil = UploadUtility.getInstance(this.globalService);
    this.uploadUtil.uploadedObjectResponse = {};
  }

  public static getInstance(globalService): UploadFolderImplementation {
    if (this.singleInstance == null) {
      this.singleInstance = new UploadFolderImplementation(globalService);
      return this.singleInstance;
    } else {
      return this.singleInstance;
    }
  }

  public async startFolderUpload(ffile,queueIndex,resolveFromQueue,uploadQueue){
    
    const classRef = this;
      if(!ffile["uploadFromButtonClick"] ){
        classRef.filesPreparinginFolder = [];
        classRef.folderFilesDnD = [];
        classRef.fileUploadInvokedDnD = false
        if (!ffile.isFile && !ffile.uploadStarted && !ffile.uploadDone) {
          new Promise(async (resolve, reject) => { 
            const item = ffile.folder
            if (item.isDirectory) {
              ffile.waiting = true;
              ffile.uploadStarted = true;
              let result = await classRef.processDirectory(item, '', ffile["parentFolderKey"]?ffile["parentFolderKey"]:ffile["currentFolderKey"], "filesAndDirs", ffile,queueIndex,ffile["tfKey"],resolveFromQueue,resolve,uploadQueue);
            }
          })
          if(ffile.filesCountInFolder == ( ffile.uploadedFilesInFolder+ffile.failedFileUploadCount+ffile.failedFileUploadZeroSizeCount)){
            return "success"
          }
        }
      }else { 
        new Promise(async (resolve, reject) => { 
          await this.startButtonClickFolderUpload(ffile,queueIndex,resolveFromQueue,resolve,uploadQueue)
        })
        if(ffile.filesCountInFolder == ( ffile.uploadedFilesInFolder+ffile.failedFileUploadCount+ffile.failedFileUploadZeroSizeCount)){
          return "success"
        }
      }
    }

  private async processDirectory(item, path, currentUploadFolder, filesAndDirs, ffile, queueIndex, tfKey,resolveFromQueue,resolveFolderUpload,uploadQueue) {
    var userData = this.localStorageService.getUserData(true);
    if (ffile.isCancelled || ffile.isError) { return; }
    const classRef = this;
    path = path || "";
    ffile.uploadStarted = true;
    ffile.waiting = false;

    try {
      var regex = new RegExp(/[/\/\\/<>:"|?*]/, 'g')
      var name = item.newName ? item.newName : item.name;
      name = name.trim();
      if (name.match(regex)) {
        name = name.replace(regex, '_');
      }
      if (currentUploadFolder != ffile.currentFolderKey && ffile.folderType == "") {
        ffile.folderType = "createNew"
      }
      let result = await classRef.createFolder(name, currentUploadFolder, ffile, tfKey);
      if(result["parentObjectKey"] == ffile["currentFolderKey"]){
        ffile["objectKey"] = result["objectKey"];
        ffile["rootFolderCreated"] = true;
      }
      if (result != undefined && result['parentObjectKey'] == userData["rootFolderKey"]) {
        var storeName = "";
        if (this.universalService.shareViewType == 'gridView') {
          storeName = "AllFiles_FolderMetadata_Date_Desc";
          if (this.universalService.sharePublicSort == '%2BobjectName') {
            storeName = "AllFiles_FolderMetadata_Name_Asc";
          }
        }
        else {//for list view
          var sortType = this.listService.listViewSortOrder;
          storeName = this.getIndexDBStoreName(sortType);
        }
        if (storeName != "") {
          var resp = await this.db.getAllData(storeName, "FolderUploadImplementation");
          if (resp) {
            let folderForIndexDB = [result]
            classRef.cacheImpl.addFolderIndexDB(folderForIndexDB)
          }
        }
        else {
          let folderForIndexDB = [result]
          classRef.cacheImpl.addFolderIndexDB(folderForIndexDB)
        }
      }
      if (ffile.folderType != "merge") {
        classRef.uploadUtil.emitUploadedObject(result);
      } else {
        if (currentUploadFolder == ffile.currentFolderKey) {
          let response = this.customMetadata.segregateData([result], 'allfiles');
          this.universalService.MarkNewObjArray.push(response[0]);
        }
      }

      if (!ffile.hasOwnProperty('circle')) {
        ffile.circle = null;
        ffile.unique = new Date().getMilliseconds() + result["objectKey"];
        setTimeout(function () { classRef.uploadUtil.fileProgressUI(ffile) }, 1000);
      }
      if (result["parentObjectKey"] == ffile.currentFolderKey) {
        ffile.isNewObject = true;
      }

      item["currentFolderKey"] = result["objectKey"];
      item['isFileInsideFolder'] = true;
      result = await  classRef.readAndUploadFolderContent(item, '', result["objectKey"], item, ffile, queueIndex, result["tfKey"],resolveFromQueue,resolveFolderUpload,uploadQueue);
        if (ffile.droppedFolderSize < 1 || ffile.filesCountInFolder < 1) {
          classRef.updateFolderPropOnSucc(ffile)
          ffile.progress = 100;
        }
    } catch (err) {
      let errorObj = err["error"];
      if (errorObj.code == "NMSOM0064" || errorObj.code == "TFOM0031") {
        if (currentUploadFolder == ffile["currentFolderKey"] ) {
          ffile.errorPopUp = true;
          ffile.errorPopUpWaiting = false;
          AppEvents.globalObservable.next({"duplicateFolder":true,"queueIndex":queueIndex});
          ffile.mergeWaiting = true;
          
          classRef.updateFolderErrProps(ffile);
          resolveFolderUpload();
          resolveFromQueue();
          
        } else if (currentUploadFolder == ffile["currentFolderKey"]) {
          ffile.errorPopUpWaiting = true
          // wait for user confirmation on the first pop up which is already opened
        } else {
          ffile.uploadDone = false;
          ffile.errorMsg = UPLOAD_CONS.ERR.FOLDER_ERR_PRGBAR;
        }
      } else if (errorObj.code == "NMSCL0021") {
        //this.initAllUploadParams();
      }
    }
  }

  private async readAndUploadFolderContent(item, path,currentUploadFolder,filesAndDirs,ffile,queueIndex,tfKey,resolveFromQueue,resolveFolderUpload,uploadQueue) {
    const classRef = this;
    const reader = item.createReader();
    let result;
      await reader.readEntries(async (entries) => { 
          for (const entry of entries) {
              if (entry.isDirectory) { 
                result =  await classRef.processDirectory(entry, path,currentUploadFolder,entry,ffile,queueIndex,tfKey,resolveFromQueue,resolveFolderUpload,uploadQueue);
              } else {
                let obj = new dragnDropObject(entry,currentUploadFolder,ffile)
                if(classRef.notAllowedExt.indexOf(entry["name"].toLowerCase()) == -1){
                  classRef.folderFilesDnD.push(obj)
                }
              }
          }
          if(classRef.folderFilesDnD.length  == ffile.filesCountInFolder && !this.fileUploadInvokedDnD) {
            this.fileUploadInvokedDnD = true
            this.fileUploadDragnDrop(ffile,queueIndex,resolveFromQueue,resolveFolderUpload,uploadQueue) 
          } 
      });
  }
  async fileUploadDragnDrop(ffile,queueIndex,resolveFromQueue,resolveFolderUpload,uploadQueue){
    for(let i=0; i<this.folderFilesDnD.length; i++){
      let obj = this.folderFilesDnD[i];
      await this.processFile(obj.entry, "",obj.currentUploadFolder,obj.entry,obj.ffile,queueIndex,"",resolveFromQueue,resolveFolderUpload,uploadQueue);
    }
    if(ffile.filesCountInFolder == ( ffile.uploadedFilesInFolder+ffile.failedFileUploadCount+ffile.failedFileUploadZeroSizeCount)){
      resolveFolderUpload()
      resolveFromQueue()
    }
  }
  private async processFile(item, path,currentUploadFolder,filesAndDirs,ffile,queueIndex,tfKey,resolveFromQueue,resolveFolderUpload,uploadQueue) {
    if (ffile.isCancelled || ffile.isError) { 
      return; 
    }
    const classRef = this;
    path = path || "";
    ffile.uploadStarted = true;
    ffile.waiting = false;

    return new Promise((resolve, reject) => {
       item.file(async function(file) {
            file.currentFolderKey = currentUploadFolder;
            if(tfKey){
              file["tfKey"] = tfKey;
            }
             await classRef.startFileUpload(file,ffile, true,queueIndex, resolve, reject,resolveFromQueue,resolveFolderUpload,uploadQueue);
          });
     });
  }

  private async startButtonClickFolderUpload(arrayData,i,resolveFromQueue,resolveFolderUpload,uploadQueue){//filesAndDirs = uploadQueue
    const classRef = this;//
      if (!arrayData.isFile && arrayData["uploadFromButtonClick"]) {
        if (!arrayData.isFile) {
          arrayData.uploadStarted = true;
          var folders = arrayData["subfolders"];
          for(let item of folders){
            await this.setSubFolderProperties(item);
          }
          this.readAndUploadSubFolders(arrayData,folders,i,resolveFromQueue,resolveFolderUpload,uploadQueue);
        }
      }else{
        
      }
  }

  setSubFolderProperties(subFolder){
    subFolder.uploadDone = false;
    subFolder.isError = false;
    subFolder.totalFilesCount = subFolder.contents.length;
    subFolder.uploadedFilesCount = 0;
  }


  async readAndUploadSubFolders(arrayData,folders,queueIndex,resolveFromQueue,resolveFolderUpload,uploadQueue){
    var classRef = this;
    var item = folders.find(fol=>fol["uploadDone"] == false);
    if(!item){
      console.log("item is undefined",item);
      return;
    }
    var find = folders.find(f=>f["folder"] == item["parent"] && f["uniqueKey"] == item["parentUniqueKey"])
    var index = folders.indexOf(find);
    index = index<=0 ? 0 : index;
    var subFolderIndex = folders.indexOf(item)
    arrayData["indexOfCurrentSubFolderBeingUploaded"] = subFolderIndex;
    var parentFolderKey = arrayData["subfolders"][index]["currentFolderKey"]?arrayData["subfolders"][index]["currentFolderKey"]:arrayData["currentFolderKey"];
    var tfKey;
    if(arrayData["locationOfUpload"].includes("teamfolders") && classRef.universalService.allowUpload){
      this.cleverTapEventsService.tfUpload();
      tfKey = arrayData["subfolders"][index]["tfKey"]?arrayData["subfolders"][index]["tfKey"]:this.universalService.currentTeamFolder["tfKey"];
    }
    var upRes =  await classRef.readAndUploadButtonClickFolderContent(queueIndex,subFolderIndex,item, parentFolderKey, "", arrayData,tfKey,resolveFromQueue,resolveFolderUpload,uploadQueue);
  }

  private async readAndUploadButtonClickFolderContent(queueIndex,subFolderIndex,item,currentUploadFolder,filesAndDirs1,ffile,tfKey,resolveFromQueue,resolveFolderUpload,uploadQueue) {
      var userData = this.localStorageService.getUserData(true);
      if (ffile.isCancelled || ffile.isError) { return; }
      const classRef = this;
      ffile.uploadStarted = true;
      ffile.waiting = false;
      if(item.isFile){
        if(tfKey){
          item["tfKey"] = tfKey
        }
        await new Promise(async (resolve, reject) => {
          await classRef.startFileUpload(item,ffile, true,queueIndex, resolve, reject,resolveFromQueue,resolveFolderUpload,uploadQueue);
        });
        if(ffile.filesCountInFolder == ( ffile.uploadedFilesInFolder+ffile.failedFileUploadCount+ffile.failedFileUploadZeroSizeCount)){
          resolveFromQueue()
          return;
        }
      }
      else {
        try {
          if(currentUploadFolder != ffile.currentFolderKey && ffile.folderType == ""){
            ffile.folderType = "createNew"
          }
          let result = await classRef.createFolder(item.folder,currentUploadFolder, ffile,tfKey);
          if(result["parentObjectKey"] == ffile["currentFolderKey"]){
            ffile["objectKey"] = result["objectKey"];
            ffile["rootFolderCreated"] = true;
          }
          if( result!=undefined && result['parentObjectKey'] ==  userData["rootFolderKey"]){
            var storeName = "";
            if(this.universalService.shareViewType == 'gridView'){
                storeName = "AllFiles_FolderMetadata_Date_Desc";
              if(this.universalService.sharePublicSort == '%2BobjectName'){
                storeName = "AllFiles_FolderMetadata_Name_Asc";
              }
            }
            else{//for list view
              var sortType = this.listService.listViewSortOrder;
              storeName = this.getIndexDBStoreName(sortType);
            }
            if(storeName!=""){
              var resp = await this.db.getAllData(storeName,"FolderUploadImplementation");
              if(resp) {
                let folderForIndexDB=[result]
                classRef.cacheImpl.addFolderIndexDB(folderForIndexDB)
              }
            }
            else{
              let folderForIndexDB=[result]
                classRef.cacheImpl.addFolderIndexDB(folderForIndexDB)
            }
          }
          if(ffile.folderType != "merge"){
            classRef.uploadUtil.emitUploadedObject(result);
          }else{
            if(currentUploadFolder == ffile.currentFolderKey){
              let response = this.customMetadata.segregateData([result], 'allfiles');
              this.universalService.MarkNewObjArray.push(response[0]);
            }
          }
        
          if (!ffile.hasOwnProperty('circle')) {
            ffile.circle = null;
            ffile.unique=new Date().getMilliseconds()+ result["objectKey"];
            setTimeout(function(){classRef.uploadUtil.fileProgressUI(ffile)}, 1000);
          }
          if (result["parentObjectKey"]== ffile.currentFolderKey) {
            ffile.isNewObject = true;
          }
          let entries = item["contents"] ;
           entries = await this.sortFilesBasedOnSize(entries);
           ffile["subfolders"][subFolderIndex]["currentFolderKey"] = result["objectKey"];
          if(result["tfKey"]){
            ffile["subfolders"][subFolderIndex]["tfKey"] = result["tfKey"];
          }
          if(entries.length == 0){
            classRef.updateUploadedFilesCountForFoldersUploadedUsingButtonClick(ffile,resolveFromQueue,resolveFolderUpload,uploadQueue);
            return;
          }
          for(let i=0; i<entries.length; i++){
            entries[i]["currentFolderKey"] = result["objectKey"];
            if(result["tfKey"]){
              entries[i]["tfKey"] = result["objectKey"]
            }
            entries[i]['isFileInsideFolder'] = true;
            await classRef.readAndUploadButtonClickFolderContent(queueIndex,subFolderIndex,entries[i], result["objectKey"], "", ffile,result["tfKey"],resolveFromQueue,resolveFolderUpload,uploadQueue);
          }
          setTimeout(function() {
            if (ffile.droppedFolderSize < 1 || ffile.filesCountInFolder < 1) {
              ffile.progress = 100;
            }
          }, 1000);  
        } catch(err) {
          let errorObj = err["error"];
          if (errorObj.code == "NMSOM0064" || errorObj.code == "TFOM0031") {
            if(currentUploadFolder == ffile["currentFolderKey"]){
              AppEvents.globalObservable.next({"duplicateFolder":true,"queueIndex":queueIndex});
              ffile.mergeWaiting = true;
              classRef.updateFolderErrProps(ffile);
              resolveFolderUpload() 
              resolveFromQueue()
            }else{
              ffile.uploadDone = false;
              ffile.errorMsg = UPLOAD_CONS.ERR.FOLDER_ERR_PRGBAR;
            }
          }else if(errorObj.code == "NMSCL0021") {
            
          } 
        }
      }  
  }

  updateUploadedFilesCountForFoldersUploadedUsingButtonClick(ffile,resolveFromQueue,resolveFolderUpload,uploadQueue){
    var classRef = this;
    if(ffile["uploadFromButtonClick"]){ // if folder uploaded from button click
      var subFolder = ffile["subfolders"][ffile["indexOfCurrentSubFolderBeingUploaded"]];
      if(!subFolder.emptyFolder){
        subFolder["uploadedFilesCount"] =  subFolder["uploadedFilesCount"] + 1;
      }
      if(subFolder["uploadedFilesCount"] == subFolder["contents"].length){
        subFolder["uploadDone"] = true;
        setTimeout(() => {
           classRef.readAndUploadSubFolders(ffile,ffile["subfolders"],ffile.index,resolveFromQueue,resolveFolderUpload,uploadQueue)
        }, 500);
      }
    }
  }

  sortFilesBasedOnSize(entries){
    entries.sort(function(subfolder1, subfolder2) {
      return subfolder1.size - subfolder2.size;
    });
    return entries;
  }


  getIndexDBStoreName(sortType) {
    if (sortType.includes("sort=%2DfileCreatedDate")) {
      return "AllFilesMetadata_List_Date_Desc";
    } else if (sortType.includes("sort=%2BfileCreatedDate")) {
      return "AllFilesMetadata_List_Date_Asc";
    } else if (sortType.includes("sort=%2DobjectName")) {
      return "AllFilesMetadata_List_Name_Desc";
    } else if (sortType.includes("sort=%2BobjectName")) {
      return "AllFilesMetadata_List_Name_Asc";
    } else if (sortType.includes("sort=%2DsizeInBytes")) {
      return "AllFilesMetadata_List_Size_Desc";
    } else if (sortType.includes("sort=%2BsizeInBytes")) {
      return "AllFilesMetadata_List_Size_Asc";
    } else if (sortType.includes("sort=%2DmimeType")) {
      return "AllFilesMetadata_List_Type_Desc";
    } else if (sortType.includes("sort=%2BmimeType")) {
      return "AllFilesMetadata_List_Type_Asc";
    }
  }

  private async createFolder(directoryname,currentUploadFolder,ffile,currentTfKey){ 
    var self = this;
    var url = window.location.href;
    if(url.includes("sharedwithme") && this.universalService.allowUpload){
      var sharedFolderDetails = this.localStorageService.getSharedFolder(true);
      return new Promise((resolve, reject)=> {
        var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nmsCollabShare"] + "/" + sharedFolderDetails.shareKey + ENV_CONFIG.commonUrls["openSharedFolder"] + "/" + currentUploadFolder;
        if(ffile["folderType"] == "merge"){
          url = url + "?folderType=M";
        }else if(ffile["folderType"] == "createNew"){
          url = url + "?folderType=N";
        }
        const newFolder = {
          objectName: directoryname
        };
        ffile.subscriptions.add(this.http.post(url, newFolder).subscribe(resolve, reject));     
      })
    } else {
      
      return new Promise(async (resolve, reject)=> {
        var url = UPLOAD_CONS.SERVICE_URL.CREATE_FOLDER;
        if(this.router.url.includes("privatefolder")){
          await  this.listService.getPPFToken();
          this.cleverTapEventsService.pfUpload();
          url = UPLOAD_CONS.SERVICE_URL.CREATE_PRIVATE_FOLDER;
        }
        var newFolder = {};


        if(this.router.url.includes("teamfolders") && this.universalService.allowUpload){
          var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["tmfldURL"] + ENV_CONFIG.commonUrls["createFolderInsideTeamFolder"];
          newFolder = {
            "parentObjectKey": currentUploadFolder,
            "tfKey": currentTfKey,
            "objectName":directoryname
          }
          url = url + "?tfKey=" + currentTfKey;
        } else {
          newFolder = {
            objectName: directoryname,
            parentObjectKey: currentUploadFolder,
            sourceName: 'DRIVE',
          };
        }

        if(ffile["folderType"] == "merge"){
          if(url.includes("?")){
            url = url + "&folderType=M";
          }else{
            url = url + "?folderType=M";
          }
        }else if(ffile["folderType"] == "createNew"){
          if(url.includes("?")){
            url = url + "&folderType=N";
          }else{
            url = url + "?folderType=N";
          }
          
        }
        ffile.subscriptions.add(this.http.post(url, newFolder).subscribe(resolve, reject));    
      })
    }
  }

  private async startFileUpload(fileObj, ffile, isfolderFileUpload,queueIndex, resolve, reject,resolveFromQueue,resolveFolderUpload,uploadQueue) {

    if(ffile.isCancelled || ffile.isError){ return;}
    var classRef = this;
    if(classRef.checkIfQuotaSuffToUploadFile(fileObj,ffile,resolveFromQueue,resolveFolderUpload)){
      if (fileObj.size < UPLOAD_CONS.SMALL_FILE_SIZE_LIMIT) {
       let result = await this.uploadSmallFile.startSmallFileUpload(fileObj, queueIndex, isfolderFileUpload,ffile,resolveFromQueue,uploadQueue) 
       if(result["status"] == "success"){
        let response = result["response"];
        classRef.cacheImpl.addFileIndexDB(response);
        classRef.updateUploadedfolderSize(ffile,response.sizeInBytes)
        classRef.updateUploadedFilesCount(ffile,resolveFromQueue,resolveFolderUpload,uploadQueue);
        classRef.getUserRemainingQuota(response.allocatedSpace, response.usedSpace)
        let progress = classRef.uploadUtil.folderUploadProgress("", ffile);
        ffile.progress = progress["progress"];
        if (ffile.circle != undefined) {
          ffile.circle.set(progress["progress_perc"]);
        }
        if (ffile.uploadedFolderSize >= ffile.droppedFolderSize) {
          this.updateFolderPropOnSucc(ffile);
          response = "success";
        }
        classRef.checkAnyErrorDuringfolderUpload(ffile);
       }else{
        classRef.smallFileUploadErrorHandler(result["response"], ffile,resolveFromQueue,resolveFolderUpload,uploadQueue)
       }
       resolve();
       return
      } else if (fileObj.size >= UPLOAD_CONS.SMALL_FILE_SIZE_LIMIT){
       let result = await classRef.uploadLargeFile.startLargeFileReadAndUpload(fileObj,queueIndex,isfolderFileUpload,ffile,resolveFromQueue,this.filesPreparinginFolder,uploadQueue)
       if(result["status"] == "success"){
          let response = result["response"];
          classRef.cacheImpl.addFileIndexDB(response);
          classRef.updateUploadedFilesCount(ffile,resolveFromQueue,resolveFolderUpload,uploadQueue);
          classRef.getUserRemainingQuota(response.allocatedSpace, response.usedSpace)
          let progress = classRef.uploadUtil.folderUploadProgress("", ffile);
          ffile.progress = progress["progress"];
          if (ffile.circle != undefined) {
            ffile.circle.set(progress["progress_perc"]);
          }
          if (ffile.uploadedFolderSize >= ffile.droppedFolderSize) {
            this.updateFolderPropOnSucc(ffile);
          }
          classRef.checkAnyErrorDuringfolderUpload(ffile);
        }else{
          classRef.handleErrorInFolderUpload(result["response"], ffile,resolveFromQueue,resolveFolderUpload,uploadQueue)

        }
       resolve();
       return
      }
    }
  }

  

  checkIfQuotaSuffToUploadFile(fileObj, ffile,resolveFromQueue,resolveFolderUpload){
    var userData = this.localStorageService.getUserData(true);
    var usedSpace = userData["quota"]["totalUsedQuota"];
    var allocatedSpace = userData["quota"]["totalAllocatedQuota"] ? userData["quota"]["totalAllocatedQuota"] : userData["quota"]["allocatedSpace"];
    this.getUserRemainingQuota(allocatedSpace,parseInt(usedSpace))
    if(!this.remainingQuota){
      this.remainingQuota = allocatedSpace - parseInt(usedSpace);
    }
    if(allocatedSpace<=parseInt(usedSpace)){
      this.universalService.showToast(UPLOAD_CONS.ERR.INSUFF_QUOTA_ERR_FOLDER_UPLD, "error");
      this.updateFolderErrProps(ffile);
      resolveFolderUpload();
      resolveFromQueue();
      return
    }

    if(this.remainingQuota && this.remainingQuota < fileObj.size){
      ffile.failedDuetoInsufficientQuota = true;
      ffile.failedFileUploadCount++;
      this.checkAnyErrorDuringfolderUpload(ffile);
      return false;
    }
    return true;
  }

  handleErrorInFolderUpload(errorObj, ffile,resolveFromQueue,resolveFolderUpload,uploadQueue){
    if(errorObj.error){
      let errorCode = errorObj.error['code'];
      if(errorCode == "TEJUM0409") {
        ffile.failedDuetoInsufficientQuota = true;
        BANNER_CONSTANTS.STORAGE_BANNER["forceShow"] = true;
        AppEvents.bannerEvent.next(BANNER_CONSTANTS.STORAGE_BANNER);
      }
      ffile.failedFileUploadCount++;
      this.checkAnyErrorDuringfolderUpload(ffile);
      this.updateUploadedFilesCountForFoldersUploadedUsingButtonClick(ffile,resolveFromQueue,resolveFolderUpload,uploadQueue); // if uploading folder using button click.If subfolder file got failed just increamenting the count of subfolder's uploaded file count as increamenting this will not impact any where.
    }  
  }
  
  private smallFileUploadErrorHandler(errorObj,ffile,resolveFromQueue,resolveFolderUpload,uploadQueue){
    let classRef = this;
    let errorCode = errorObj.error['code'] || errorObj.error['responseCode'];
    if(errorObj && errorCode == "TEJUF0422"){
      if (ffile.uploadedFolderSize >= ffile.droppedFolderSize) {
        classRef.updateFolderPropOnSucc(ffile)
      }
      ffile.failedFileUploadZeroSizeCount++;
      this.updateUploadedFilesCountForFoldersUploadedUsingButtonClick(ffile,resolveFromQueue,resolveFolderUpload,uploadQueue); // if uploading folder using button click.If subfolder file got failed just increamenting the count of subfolder's uploaded file count as increamenting this will not impact any where.
    }
    else{
      classRef.handleErrorInFolderUpload(errorObj,ffile,resolveFromQueue,resolveFolderUpload,uploadQueue)
    }    
  }

  getUserRemainingQuota(allocatedSpace, usedSpace){
    this.remainingQuota = allocatedSpace - usedSpace;
    var userData = this.localStorageService.getUserData(true);
    if(userData && userData["quota"]){
      userData["quota"]["totalUsedQuota"] =  usedSpace;
      AppEvents.updateAuthData.next({updateAuthData:true,userData:userData,updateStorageRepresentationOnUI:true});
      AppEvents.bannerEvent.next(BANNER_CONSTANTS.STORAGE_BANNER);
    }
  }

  private updateUploadedfolderSize(ffile, sizeInBytes){
    ffile.uploadedFolderSize = ffile.uploadedFolderSize + sizeInBytes;
  }

  private updateUploadedFilesCount(ffile,resolveFromQueue,resolveFolderUpload,uploadQueue){ 
    var classRef = this;
    ffile.uploadedFilesInFolder = ffile.uploadedFilesInFolder + 1;
    classRef.updateUploadedFilesCountForFoldersUploadedUsingButtonClick(ffile,resolveFromQueue,resolveFolderUpload,uploadQueue);
  }

  checkAnyErrorDuringfolderUpload(ffile){
    let classRef = this;
    if((ffile.filesCountInFolder- ffile.uploadedFilesInFolder - ffile.failedFileUploadCount-ffile.failedFileUploadZeroSizeCount) == 0){
      if(ffile.failedFileUploadCount>=1){
        if(ffile.failedDuetoInsufficientQuota){
          classRef.universalService.showToast(UPLOAD_CONS.ERR.INSUFF_QUOTA_ERR_FOLDER_UPLD, "error");
        }
        classRef.updateFolderErrProps(ffile);
      }
    } 
  }

  private updateFolderPropOnSucc(ffile){
    ffile.isError = false;
    ffile.hideProgress = true;
    ffile.uploadStarted = false;
    ffile.preparingUpload = false;
    ffile.uploadDone = true;
    ffile.waiting = false;
    ffile.uploadedFolderSize = ffile.droppedFolderSize; // in few scenarios of chunk upload, there is a minor 0.0X mbs of difference in file sizes, so if the uploadedFolderSize>droppedFolderSize assigning the dropped folder size to uploaded folder size
    this.cleverTapEventsService.fileUpload(ffile)
  }

  abortReadingOfAllFilesInFolder(){
    this.filesPreparinginFolder.forEach(file => {
      file.fileReader.abort();
    });
  }

  private updateFolderErrProps(ffile){
    ffile.isError = true;
    ffile.uploadStarted = false;
    ffile.uploadDone = false;
    ffile.waiting = false;
    ffile.isCancelled = true;
  }

  
  removeFromFaileduploadArray(file){
    let classRef = this;
    const index = classRef.failedUploads.findIndex((item)=> {
      return item.index == file.index; 
    })
    if(index > -1) {
      classRef.failedUploads.splice(index, 1);
    }
  }  
}